// 自定义指令，el-select 滚动到底部执行回调函数
export const selectLoadMore = (Vue)=>{
    Vue.directive('selectLoadMore',{
        bind (el, binding) {
            // 获取element-ui定义好的scroll盒子
            const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
            SELECTWRAP_DOM.addEventListener('scroll', function () {
                if (this.scrollHeight - this.scrollTop < this.clientHeight + 5) {
                    binding.value()
                }
            })
        }
    })
}

// 自定义指令，el-table 滚动到底部执行回调函数
export const tableLoadMore = (Vue)=>{
    Vue.directive('tableLoadMore',{
        bind (el, binding) {
            // 获取element-ui定义好的scroll盒子
            const SELECTWRAP_DOM = el.querySelector('.el-table__body-wrapper')
            SELECTWRAP_DOM.addEventListener('scroll', function () {
                if (this.scrollHeight - this.scrollTop < this.clientHeight + 30) {
                    binding.value()
                }
            })
        }
    })
}
